// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider:first-child {
  border-width: 0;
}
ion-item-divider#searchbar-wrapper {
  --padding-start: 0px;
  --inner-padding-end: 0px;
}

#contact-list ion-item ion-label h4 {
  font-size: 17px;
  font-weight: 500;
}
#contact-list ion-item ion-label p.contact-phone {
  font-size: 16px;
  font-weight: 500;
}
#contact-list ion-item ion-label p.contact-type {
  font-size: 14px;
  font-weight: 500;
}
#contact-list ion-item ion-icon {
  border: 1px solid var(--ion-color-primary, black);
  font-size: 24px;
  padding: 6px;
  border-radius: 50%;
}
#contact-list ion-item ion-icon:last-child {
  margin-right: 16px;
}

#no-contacts-list {
  height: calc(100% - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.skeleton ion-avatar {
  border: 1px solid lightgray;
}

ion-segment-button {
  font-size: 12px;
}

#no-found {
  font-weight: 700;
}

#cont-button-add {
  text-align: center;
  color: var(--ion-color-primary, black);
  font-size: 14px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment/list-contacts/list-contacts.page.scss"],"names":[],"mappings":"AACE;EAEE,eAAA;AADJ;AAIE;EACE,oBAAA;EACA,wBAAA;AAFJ;;AASM;EACE,eAAA;EACA,gBAAA;AANR;AAQM;EACE,eAAA;EACA,gBAAA;AANR;AAQM;EACE,eAAA;EACA,gBAAA;AANR;AASI;EACE,iDAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAPN;AAQM;EACE,kBAAA;AANR;;AAYA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AATF;;AAaE;EACE,2BAAA;AAVJ;;AAcE;EACE,eAAA;AAXJ;;AAcE;EACE,gBAAA;AAXJ;;AAeE;EACE,kBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AAZJ","sourcesContent":["ion-item-divider {\n  &:first-child {\n    //background: red !important;\n    border-width: 0;\n  }\n\n  &#searchbar-wrapper {\n    --padding-start: 0px;\n    --inner-padding-end: 0px;\n  }\n}\n\n#contact-list {\n  ion-item {\n    ion-label {\n      h4 {\n        font-size: 17px;\n        font-weight: 500;\n      }\n      p.contact-phone {\n        font-size: 16px;\n        font-weight: 500;\n      }\n      p.contact-type {\n        font-size: 14px;\n        font-weight: 500;\n      }\n    }\n    ion-icon {\n      border: 1px solid var(--ion-color-primary, black);\n      font-size: 24px;\n      padding: 6px;\n      border-radius: 50%;\n      &:last-child {\n        margin-right: 16px;\n      }\n    }\n  }\n}\n\n#no-contacts-list {\n  height: calc(100% - 60px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.skeleton {\n  ion-avatar {\n    border: 1px solid lightgray;\n  }\n}\n\n  ion-segment-button {\n    font-size: 12px;\n  }\n\n  #no-found{\n    font-weight: 700;\n  }\n\n\n  #cont-button-add {\n    text-align: center;\n    color: var(--ion-color-primary, black);\n    font-size: 14px;\n    font-weight: 700;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
